import { BAND_HEIGHT } from "./Band"
import { Money } from "@oysterhr/schema"
import { useDimensionsContext } from "./DimensionsProvider"
import { convertSubunitIntoUnit, SimpleMoney } from "@oysterhr/common"
import { CHART_TOP_MARGIN } from "./utils"
import { useTranslation } from "react-i18next"

type SalaryIconProps = {
  salary: Money
}

export function SalaryIcon({ salary }: SalaryIconProps) {
  const { t } = useTranslation("salary_insights_tool/chart")
  const ctx = useDimensionsContext()
  const radius = BAND_HEIGHT / 2
  const YPos = CHART_TOP_MARGIN

  const salaryUnit = convertSubunitIntoUnit(salary.subunit, salary.currencyCode)

  let XPos = (salaryUnit - ctx.lowestTick) / ctx.scale
  let textAlign = "middle"

  if (XPos >= ctx.boundedWidth - radius) {
    XPos = ctx.boundedWidth
    textAlign = "end"
  }

  if (salaryUnit <= ctx.lowestTick) {
    XPos = 0
    textAlign = "start"
  }

  const ICON_HEIGHT = 10
  const ICON_WIDTH = 16
  return (
    <>
      <text x={XPos} y={YPos - 24} style={{ fontSize: 12 }} textAnchor={textAlign}>
        <tspan className="text-gray-400">{t("yourSalary")}</tspan>
        <tspan x={XPos} dy="14px" className="font-semibold text-black">
          {SimpleMoney.from(salary).format({
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
          })}
        </tspan>
      </text>
      <circle cx={XPos} cy={YPos + radius} r={radius} className="fill-white stroke-black" />
      <svg
        width={ICON_WIDTH}
        height={ICON_HEIGHT}
        viewBox="0 0 16 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        y={YPos + radius - ICON_HEIGHT / 2}
        x={XPos - ICON_WIDTH / 2}
      >
        <path
          d="M11 1L15 4.5M11 9L15 5.5M5 1L1 4.5M5 9L1 5.5M1.5 1H14.5C14.7761 1 15 1.22386 15 1.5V8.5C15 8.77614 14.7761 9 14.5 9H1.5C1.22386 9 1 8.77614 1 8.5V1.5C1 1.22386 1.22386 1 1.5 1ZM10 5C10 6.10457 9.10457 7 8 7C6.89543 7 6 6.10457 6 5C6 3.89543 6.89543 3 8 3C9.10457 3 10 3.89543 10 5Z"
          stroke="#171717"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )
}
